import { ConfigSection } from './GeneralConfig'
import { useMemo, type FC } from 'react'
import { getUseConfigStore } from '../../stores/useConfigStore'
import { Globe, Phone, Mail } from 'lucide-react'
import { Input, Label } from '@bpinternal/ui-kit-next'

type Props = {
  workspaceId: string
  botId: string
}

export const ContactSection: FC<Props> = ({ workspaceId, botId }) => {
  const useConfigStore = useMemo(() => getUseConfigStore({ botId, workspaceId }), [botId, workspaceId])

  const email = useConfigStore((state) => state.email)
  const phone = useConfigStore((state) => state.phone)
  const privacyPolicy = useConfigStore((state) => state.privacyPolicy)
  const termsOfService = useConfigStore((state) => state.termsOfService)
  const website = useConfigStore((state) => state.website)

  const setEmail = useConfigStore((state) => state.setEmail)
  const setPhone = useConfigStore((state) => state.setPhone)
  const setPrivacyPolicy = useConfigStore((state) => state.setPrivacyPolicy)
  const setTermsOfService = useConfigStore((state) => state.setTermsOfService)
  const setWebsite = useConfigStore((state) => state.setWebsite)

  return (
    <ConfigSection title="Contact" description="Contact information for your bot.">
      <div className="flex flex-col gap-4">
        <div className="relative">
          <Mail className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
          <Input
            className="pl-10"
            placeholder="example@example.com"
            value={email?.link ?? ''}
            onChange={(e) => setEmail({ title: e.target.value, link: e.target.value })}
          />
        </div>

        <div className="relative">
          <Phone className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
          <Input
            className="pl-10"
            placeholder="+1 555 555 5555"
            value={phone?.link ?? ''}
            onChange={(e) => setPhone({ title: e.target.value, link: e.target.value })}
          />
        </div>

        <div className="relative">
          <Globe className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
          <Input
            className="pl-10"
            placeholder="https://example.com"
            value={website?.link ?? ''}
            onChange={(e) => setWebsite({ title: e.target.value, link: e.target.value })}
          />
        </div>

        <div>
          <Label className="text-muted-foreground">Terms of service</Label>
          <Input
            placeholder="https://example.com/terms"
            value={termsOfService?.link ?? ''}
            onChange={(e) => setTermsOfService({ title: 'Terms of service', link: e.target.value })}
          />
        </div>

        <div>
          <Label className="text-muted-foreground">Privacy policy</Label>
          <Input
            placeholder="https://example.com/privacy"
            value={privacyPolicy?.link ?? ''}
            onChange={(e) => setPrivacyPolicy({ title: 'Privacy policy', link: e.target.value })}
          />
        </div>
      </div>
    </ConfigSection>
  )
}
